import { FC } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import ArtifactTable from '../ArtifactTable';
import DownloadReportButton from '../DownloadReportButton';
import { FinalizeTabProps } from '../ReportDialog.props';
import { formatWhen } from '../ReportDialog.utils';

const FinalizeTab: FC<FinalizeTabProps> = ({
  columns,
  rows,
  day,
  isFinalized,
  isSent,
  isStaff,
  validationPassed,
  hasGeneratedReport,
  approverNote,
  onApproverNoteChange,
  unfinalizeReason,
  onUnfinalizeReasonChange,
  canConfirmFinalize,
  isFinalizing,
  isUnfinalizing,
  onFinalize,
  onUnfinalize,
  canDownloadReport,
  isDownloadingDocuments,
  onDownload,
}) => (
  <Box data-testid="daily-nav-report-finalize">
    <ArtifactTable columns={columns} rows={rows} />
    {isFinalized ? (
      <Box mt={2}>
        <Typography variant="body2" data-testid="daily-nav-finalized-by">
          Finalized by {day?.finalized_by_name || 'Unknown'}
        </Typography>
        {day?.finalized_at && (
          <Typography variant="body2" mt={1} data-testid="daily-nav-finalized-at">
            Finalized at {formatWhen(day.finalized_at)}
          </Typography>
        )}
        {canDownloadReport && (
          <DownloadReportButton isDownloading={isDownloadingDocuments} onClick={onDownload} />
        )}
        {!isSent && (
          <Box mt={2}>
            <Typography variant="body2">Un-finalize requires a reason and keeps the prior finalize attribution.</Typography>
            <TextField
              id="daily-nav-unfinalize-reason"
              data-testid="daily-nav-unfinalize-reason"
              fullWidth
              margin="dense"
              size="small"
              multiline
              minRows={2}
              label="Reason"
              value={unfinalizeReason}
              onChange={event => onUnfinalizeReasonChange(event.target.value)}
            />
            <Button
              data-testid="daily-nav-unfinalize-button"
              sx={{ mt: 1, textTransform: 'none' }}
              disabled={!unfinalizeReason.trim() || isUnfinalizing}
              onClick={onUnfinalize}>
              Un-finalize
            </Button>
          </Box>
        )}
      </Box>
    ) : (
      <Box mt={2}>
        {!validationPassed && (
          <Typography variant="body2" color="error.main">
            Validation must pass before this day can be finalized.
          </Typography>
        )}
        {!hasGeneratedReport && validationPassed && (
          <Typography variant="body2" color="error.main">
            Generate and review the report preview before finalizing.
          </Typography>
        )}
        {isStaff && (
          <TextField
            id="daily-nav-finalize-approver-note"
            data-testid="staff-finalize-confirmation-input"
            fullWidth
            margin="dense"
            size="small"
            multiline
            minRows={3}
            label="Who approved these prices"
            value={approverNote}
            onChange={event => onApproverNoteChange(event.target.value)}
          />
        )}
        <Button
          data-testid="confirm-finalize-daily-nav-button"
          variant="contained"
          sx={{ mt: 1, textTransform: 'none' }}
          disabled={!canConfirmFinalize || isFinalizing}
          onClick={onFinalize}>
          Finalize
        </Button>
      </Box>
    )}
  </Box>
);

export default FinalizeTab;
